export default "__VITE_ASSET__OkyGfnkKOKjxvbH0mJafLw__"